import React from 'react'

class HorizontalRule extends React.Component {
  render() {
    return <div className="hr" />
  }
}

export default HorizontalRule
